module.exports = __webpack_public_path__ + "img/covid19screeningtoolconcept.f37dd662.png";